module.exports = __webpack_public_path__ + "1305ef65f00b55a0fabddd5d637179d0.svg";